import React, { useState } from "react";
import {
  Box,
  Button,
  Divider,
  Grid,
  Typography,
  Stack,
  MenuItem,
} from "@mui/material";
import ModalCustom from "../../../components/Modal";
import CustomTextField from "../../../components/TextField";
import ClearIcon from "@mui/icons-material/Clear";
import axiosInstance from "../../../utils/api/api";
import toast, { Toaster } from "react-hot-toast";
import succesSound from "../../../assets/audio/success.mp3";
import errorSound from "../../../assets/audio/error.mp3";

const AddSupplier = ({ open, setModalOpen, getSuppliers }) => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [category, setCategory] = useState("Choose category");
  const token = JSON.parse(localStorage.getItem("userToken"));
  const authentication = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const succesEffect = new Audio(succesSound);
  const errorEffect = new Audio(errorSound);

  const type = [
    {
      _id: "0",
      name: "Dyestuff",
      value: "Dyestuff",
    },
    {
      _id: "1",
      name: "Auxiliaries",
      value: "Auxiliaries",
    },
    {
      _id: "2",
      name: "Both",
      value: "Auxiliaries & Dyestuff",
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const data = {
      name: name,
      email: email,
      phone_number: phone,
      address: address,
      city: city,
      category: category,
    };

    axiosInstance
      .post("/api/suppliers", data, authentication)
      .then(() => {
        // console.log(res.data);
        succesEffect.play();
        toast.success("New supplier data added!");
        getSuppliers();
        setModalOpen(false);
      })
      .catch((error) => {
        errorEffect.play();
        console.log(error);
        toast.error("Oops! Something went wrong. Please try again.");
      });
  };

  const handleClose = () => {
    setName("");
    setEmail("");
    setPhone("");
    setAddress("");
    setCategory("");
    setModalOpen(false);
  };

  return (
    <>
      <Toaster position="top-center" reverseOrder={false} />
      <ModalCustom
        open={open}
        handleClose={() => setModalOpen(false)}
        cardStyle={{ borderRadius: 2, width: 740, height: "auto" }}
      >
        {/* Header */}
        <Box>
          <Box
            sx={{
              p: 2,
            }}
          >
            <Stack direction="row" justifyContent="space-between">
              <Typography fontSize="16px" fontWeight="600">
                Create Supplier Data
              </Typography>
              <Grid item>
                <ClearIcon
                  sx={{ cursor: "pointer" }}
                  onClick={() => handleClose()}
                />
              </Grid>
            </Stack>
          </Box>
          <Divider />
        </Box>

        {/* Body */}
        <form onSubmit={handleSubmit}>
          <Box flex="1">
            <Stack paddingX={2} paddingY={2} gap={2}>
              <Stack direction={"row"} gap={1} justifyContent={"space-between"}>
                <Grid item width={"100%"}>
                  <CustomTextField
                    name="category"
                    label="Category"
                    placeholder="Choose category"
                    onChange={(e) => setCategory(e.target.value)}
                    value={category}
                    select
                  >
                    <MenuItem value={"Choose category"}>
                      Choose category
                    </MenuItem>
                    {type.map((dt) => (
                      <MenuItem key={dt._id} value={dt.value}>
                        {dt.name}
                      </MenuItem>
                    ))}
                  </CustomTextField>
                </Grid>
              </Stack>

              <Stack gap={2}>
                <Stack
                  direction={"row"}
                  gap={1}
                  justifyContent={"space-between"}
                >
                  <Grid item width={"100%"}>
                    <CustomTextField
                      name="name"
                      label="Full Name"
                      placeholder="Input a full name"
                      onChange={(e) => setName(e.target.value)}
                    />
                  </Grid>
                </Stack>
                <Stack
                  direction={"row"}
                  gap={1}
                  justifyContent={"space-between"}
                >
                  <Grid item width={"50%"}>
                    <CustomTextField
                      name="email"
                      label="Email"
                      placeholder="Input the supplier's email"
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </Grid>
                  <Grid item width={"50%"}>
                    <CustomTextField
                      name="phone_number"
                      label="Phone"
                      placeholder="Input phone number"
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </Grid>
                </Stack>
                <Stack
                  direction={"row"}
                  gap={1}
                  justifyContent={"space-between"}
                >
                  <Grid item width={"100%"}>
                    <CustomTextField
                      name="city"
                      label="City"
                      placeholder="Input a city name"
                      onChange={(e) => setCity(e.target.value)}
                    />
                  </Grid>
                </Stack>
                <Grid item xs={12}>
                  <CustomTextField
                    name="address"
                    label="Address"
                    type="text"
                    multiline
                    rows={4}
                    placeholder="Input full address"
                    onChange={(e) => setAddress(e.target.value)}
                  />
                </Grid>
              </Stack>
            </Stack>
          </Box>
          <Box sx={{ backgroundColor: "#f6f6f6" }}>
            <Box
              sx={{
                px: 3,
                py: 2,
              }}
            >
              <Stack direction="row" justifyContent="right">
                <Button
                  sx={{
                    textTransform: "capitalize",
                    marginRight: "16px",
                    borderRadius: "6px",
                    backgroundColor: "#FFF",
                    color: "#222",
                    border: "1px solid #222",
                    ":hover": {
                      backgroundColor: "#FFF",
                      border: "1px solid #222",
                    },
                  }}
                  variant="outlined"
                  onClick={() => handleClose()}
                >
                  Cancel
                </Button>
                <Button
                  sx={{
                    textTransform: "capitalize",
                    backgroundColor: "#222",
                    color: "#FFF",
                    borderRadius: "6px",
                    ":hover": {
                      backgroundColor: "#444",
                    },
                  }}
                  type="submit"
                  variant="contained"
                  disabled={
                    name === "" ||
                    email === "" ||
                    phone === "" ||
                    address === "" ||
                    city === ""
                      ? true
                      : false
                  }
                >
                  Save
                </Button>
              </Stack>
            </Box>
          </Box>
        </form>
      </ModalCustom>
    </>
  );
};

export default AddSupplier;
